import get from 'lodash/get';
import { of } from 'rxjs';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  Locale,
  ManifestAccessorFn,
} from '@cigna/shared/angular/resource-content-data-access';
import {
  ContentBundleManifest,
  ContentBundleName,
} from './content-bundle.interfaces';

export const manifestAccessorFactory =
  (): ManifestAccessorFn =>
  (
    bundleName: ContentBundleName,
    manifest: ContentBundleManifest,
    lang: Locale,
  ) => {
    const filePaths = [`public.${lang.toLowerCase()}.${bundleName}`];
    const fileNames = filePaths.map((p) => get(manifest, p)).filter((_) => _);
    if (fileNames.length === 0) {
      // eslint-disable-next-line no-console
      console.warn(
        `could not find base requested bundle in manifest at: ${filePaths[0]}`,
      );
    }
    return of(fileNames);
  };
